// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 964) return "js/bundle/964.js";
	// return url for filenames based on template
	return undefined;
};